import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContractsComponent } from './pages/contracts/contracts.component';
import { CreateContractComponent } from './pages/create-contract/create-contract.component';
import { HomeComponent } from './pages/home/home.component';
import { SigninComponent } from './pages/signin/signin.component';
import { AppLayoutComponent } from './components/layout/app-layout/app-layout.component';
import { CreateEmployeeComponent } from './pages/create-employee/create-employee.component';
import { CreateSkillComponent } from './pages/create-skill/create-skill.component';
import { CreateVendorComponent } from './pages/create-vendor/create-vendor.component';
import { SkillsComponent } from './pages/skills/skills.component';
import { VendorsComponent } from './pages/vendor/vendors.component';
import { AuthenticationGuard } from './interceptors/auth.guard';
import { CreateCostCenterComponent } from './pages/create-costcenter/create-costcenter.component';
import { CostCentersComponent } from './pages/costcenters/costcenters.component';
import { CreateLocationComponent } from './pages/create-location/create-location.component';
import { LocationsComponent } from './pages/locations/locations.component';
import { ApproveContractsComponent } from './pages/approvecontract/approvecontracts.component';
import { DesignationsComponent } from './pages/designations/designations.component';
import { UsersComponent } from './pages/users/users.component';
import { CreateuserComponent } from './pages/createuser/createuser.component';
import { ManagerolepermissionComponent } from './pages/managerolepermission/managerolepermission.component';
import { CreateRoleComponent } from './pages/create-role/create-role.component';
import { EmployeesComponent } from './pages/employees/employees.component';
import { CreateDesignationComponent } from './pages/create-designation/create-designation.component';
import { ApprovallevelsComponent } from './pages/approvallevels/approvallevels.component';
import { ViewVerifyEmployeeComponent } from './pages/view-verify-employee/view-verify-employee.component';
import { ViewVerifyEmployeeDetailComponent } from './pages/view-verify-employee-detail/view-verify-employee-detail.component';
import { ChangepasswordComponent } from './pages/changepassword/changepassword.component';
import { ExpressApprovalsComponent } from './pages/expressapproval/expressapprovals.component';
import { NewExpressApprovalComponent } from './components/new-express-approval/new-express-approval.component';
import { EmployeeFileUploadsComponent } from './components/employee-file-uploads/employee-file-uploads.component';
import { RequestReportsComponent } from './components/request-reports/request-reports.component';
import { EmployeeReportsComponent } from './components/employee-reports/employee-reports.component';
import { EmpInductionsComponent } from './components/emp-inductions/emp-inductions.component';
import { ViewSafetyinductionComponent } from './pages/view-safetyinduction/view-safetyinduction.component';
import { ChangeempComponent } from './components/changeemp/changeemp.component';
import { SafetyinductionComponent } from './components/safetyinduction/safetyinduction.component';
import { RolesComponent } from './pages/roles/roles.component';
import { CreateManpowerComponent } from './pages/create-manpower/create-manpower.component';
import { FirstLogonComponent } from './pages/first-logon/first-logon.component';
import { ContractsemployeesComponent } from './components/contractsemployees/contractsemployees.component';
//import { ApproveComponent } from './pages/approve/approve.component';
import { ApprovemanpowerComponent } from './pages/approvemanpower/approvemanpower.component';
import { ApproveComponent } from './pages/approve/approve.component';
import { ManpowerComponent } from './pages/manpower/manpower.component';
import { CreateMovementComponent } from './pages/create-movement/create-movement.component';
import { ApprovemovementComponent } from './pages/approvemovement/approvemovement.component';
import { MovementComponent } from './pages/movement/movement.component';
import { ApprovemvtComponent } from './pages/approvemvt/approvemvt.component';
import { ApprovemnpComponent } from './pages/approvemnp/approvemnp.component';
import { ApprovemanpComponent } from './pages/approvemanp/approvemanp.component';
import { MovementReportsComponent } from './components/movement-reports/movement-reports.component';
import { ManpowerReportsComponent } from './components/manpower-reports/manpower-reports.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ApprovedmanpowerrequestComponent } from './pages/approvedmanpowerrequest/approvedmanpowerrequest.component';
import { ApprovedmovementrequestComponent } from './pages/approvedmovementrequest/approvedmovementrequest.component';
import { ApprovedcontractComponent } from './pages/approvedcontract/approvedcontract.component';
import { ManpowerrecruitmentComponent } from './pages/manpowerrecruitment/manpowerrecruitment.component';
import { RecruitmentReportsComponent } from './components/recruitment-reports/recruitment-reports.component';
import { ConfirmtoolsComponent } from './components/confirmtools/confirmtools.component'
import { NewExitclearanceComponent } from './pages/new-exitclearance/new-exitclearance.component';
import { ApproveExitClearanceComponent } from './pages/approve-exit-clearance/approve-exit-clearance.component';
import { AuthorizeExitClearanceComponent } from './pages/authorize-exit-clearance/authorize-exit-clearance.component';
import { ExitClearanceFormsComponent } from './pages/exit-clearance-forms/exit-clearance-forms.component';
import { ExitClearanceReportComponent } from './pages/exit-clearance-report/exit-clearance-report.component';
import { ExitEmployeeUserMgtComponent } from './pages/exit-employee-user-mgt/exit-employee-user-mgt.component';
import { ConfirmClearanceComponent } from './pages/confirm-clearance/confirm-clearance.component';
import { ManpowerDraftsComponent } from './components/manpower-drafts/manpower-drafts.component';
import { EditManpowerDraftComponent } from './components/edit-manpower-draft/edit-manpower-draft.component';
import { NewAdhocComponent } from './components/new-adhoc/new-adhoc.component';
import { ViewApproveadhocComponent } from './components/view-approveadhoc/view-approveadhoc.component';
import { ViewAdhocComponent } from './components/view-adhoc/view-adhoc.component';
import { ViewAxiomComponent } from './components/view-axiom/view-axiom.component';
import { NewAxiomComponent } from './components/new-axiom/new-axiom.component';
import { NewJobRotationComponent } from './components/new-job-rotation/new-job-rotation.component';
import { ViewJobRotationsComponent } from './components/view-job-rotations/view-job-rotations.component';
import { ApproveJobRotationComponent } from './components/approve-job-rotation/approve-job-rotation.component';
import { AdhocRequestReportsComponent } from './components/request-reports/adhoc-request-reports/adhoc-request-reports.component';
import { AllContractsComponent } from './pages/allcontracts/all-contracts/all-contracts.component';
import { ViewAllContractsComponent } from './components/viewallcontracts/view-all-contracts/view-all-contracts.component';
import { NewhireonboardingComponent } from './components/newhireonboarding/newhireonboarding.component';
import { DocumentationNewHireComponent } from './components/documentation-new-hire/documentation-new-hire.component';
import { NewHiresViewComponent } from './components/new-hires-view/new-hires-view.component';

//import { ConfirmtoolsComponent } from './components/confirmtools/confirmtools.component';

const routes: Routes = [

  
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        data: { title: 'Dashboard' }
      },

      {
        path: 'createrequest',
        component: CreateContractComponent,
        data: { title: 'createrequest' }
      },

      {
        path: 'requests',
        component: ContractsComponent,
        data: { title: 'Request' }
      },

      {
        path: 'approverequests',
        component: ApproveContractsComponent,
        data: { title: 'Request' }
      },

      {
        path: 'approvedrequests',
        component: ApprovedcontractComponent,
        data: { title: 'Request' }
      },
      {
        path: 'allrequests',
        component: ViewAllContractsComponent,
        data: { title: 'allrequests' }
      },

      {
        path: 'manpowerrecruitments',
        component: ManpowerrecruitmentComponent,
        data: { title: 'manpowerrecruitment' }
      },

      {
      path: 'newhire',
      component: NewhireonboardingComponent,
      data: { title: 'New Hire Onboarding' }
      },
     {
        path: 'new-hires-view',
        component: NewHiresViewComponent,
        data: { title: 'new-hires-view' }
      },
    
      {
        path: 'expressapproval',
        component: ExpressApprovalsComponent,
        data: { title: 'Request' }
      },

      {
        path: 'createemployee',
        component: CreateEmployeeComponent,
        data: { title: 'Employee' }
      },

      {
        path: 'employees',
        component: EmployeesComponent,
        data: { title: 'Employees' }
      },

      {
        path: 'verifyemployees',
        component: ViewVerifyEmployeeComponent,
        data: { title: 'Employees' }
      },

      {
        path: 'verifyemployees/:id',
        component: ViewVerifyEmployeeDetailComponent,
        data: { title: 'Employees' }
      },

      {
        path: 'createskill',
        component: CreateSkillComponent,
        data: { title: 'Skill' }
      },

      {
        path: 'skills',
        component: SkillsComponent,
        data: { title: 'Skills' }
      },

      {
        path: 'createvendor',
        component: CreateVendorComponent,
        data: { title: 'Vendor' }
      },

      {
        path: 'vendors',
        component: VendorsComponent,
        data: { title: 'Vendors' }
      },

      {
        path: 'createcostcenter',
        component: CreateCostCenterComponent,
        data: { title: 'Cost Center' }
      },
    
      {
        path: 'costcenters',
        component: CostCentersComponent,
        data: { title: 'Cost Centers' }
      },

      {
        path: 'createlocation',
        component: CreateLocationComponent,
        data: { title: 'Location' }
      },

      {
        path: 'locations',
        component: LocationsComponent,
        data: { title: 'Locations' }
      },
      {
        path: 'createaxiom',
        component: NewAxiomComponent,
        data: { title: 'Axiom' }
      },

      {
        path: 'axioms',
        component: ViewAxiomComponent,
        data: { title: 'Axioms' }
      },
      
      {
        path: 'createdesignation',
        component: CreateDesignationComponent,
        data: { title: 'Designation' }
      },

      {
        path: 'designations',
        component: DesignationsComponent,
        data: { title: 'Designations' }
      },

      {
        path: 'users',
        component: UsersComponent,
        data: { title: 'users' }
      },

      {
        path: 'viewroles',
        component: RolesComponent,
        data: { title: 'ViewRole' }
      },

      {
        path: 'createuser',
        component: CreateuserComponent,
        data: { title: 'createuser' }
      },

      {
        path: 'managerolepermissions',
        component: ManagerolepermissionComponent,
        data: { title: 'managerolepermissions' }
      },

      {
        path: 'movement',
        component: CreateMovementComponent,
        data: { title: 'movement' }
      },


      {
        path: 'movementrequest',
        component: MovementComponent,
        data: { title: 'movementrequest' }
      },

      {
        path: 'approvemovementrequests',
        component: ApprovemovementComponent,
        data: { title: 'approvemovement' }
      },

      {
        path: 'approvedmovementrequests',
        component: ApprovedmovementrequestComponent,
        data: { title: 'approvedmovementrequest' }
      },

      {
        path: 'manpower',
        component: CreateManpowerComponent,
        data: { title: 'manpower' }
      },

      {
        path: 'mnpps',
        component: ApprovemnpComponent,
        data: { title: 'mnpps' }
      },
      {
        path: 'mvp',
        component: ApprovemvtComponent,
        data: { title: 'mvp' }
      },

      {
        path: 'manpowerrequest',
        component: ManpowerComponent,
        data: { title: 'manpowerrequest' }
      },
      {
        path: 'manpowerdrafts',
        component: ManpowerDraftsComponent,
        data: { title: 'manpowerdrafts' }
      },
      {
        path: 'update-manpower-request',
        component: EditManpowerDraftComponent,
        data: { title: 'update-manpower-request' }
      },

      {
        path: 'approvemanpowerrequests',
        component: ApprovemanpowerComponent,
        data: { title: 'Request' }
      },
      {
        path: 'approvedmanpowerrequests',
        component: ApprovedmanpowerrequestComponent,
        data: { title: 'approvedmanpowerrequests' }
      },

      {
        path: 'createrole',
        component: CreateRoleComponent,
        data: { title: 'Role' }
      },
      {
        path: 'approvallevels',
        component: ApprovallevelsComponent,
        data: { title: 'approvallevels' }
      },
      {
        path: 'changepassword',
        component: ChangepasswordComponent,
        data: { title: 'changepassword' }
      },

      {
        path: 'profile',
        component: ProfileComponent,
        data: { title: 'profile' }
      },

      {
        path: 'createexpressapproval',
        component: NewExpressApprovalComponent,
        data: { title: 'createexpressapproval' }
      },
      
      {
        path: 'employeedocuments',
        component: EmployeeFileUploadsComponent,
        data: { title: 'employeedocuments' }
      },
  
      
      {
        path: 'requestreports',
        component: RequestReportsComponent,
        data: { title: 'requestreports' }
      },

      {
        path: 'movementsreports',
        component: MovementReportsComponent,
        data: { title: 'movementsreports' }
      },

      {
        path: 'manpowerreports',
        component: ManpowerReportsComponent,
        data: { title: 'manpowerreports' }
      },
      {
        path: 'recruitmentreports',
        component: RecruitmentReportsComponent,
        data: { title: 'recruitmentreports' }
      },
     
      {
        path: 'employeereports',
        component: EmployeeReportsComponent,
        data: { title: 'employeereports' }
      },
      {
        path: 'employeeinduction',
        component: EmpInductionsComponent,
        data: { title: 'employeeinduction' }
      },
      

      {
        path: 'biometricinduction',
        component: ViewSafetyinductionComponent,
        data: { title: 'safetyinduction' }
      },
      {
        path: 'pendingapprovals',
        component: ChangeempComponent,
        data: { title: 'changestaffcount' }
      },
      {
        path: 'safetyinduction',
        component: SafetyinductionComponent,
        data: { title: 'safetyinduction' }
      },
      {
        path: 'contractsemployees',
        component: ContractsemployeesComponent,
        data: { title: 'contractsemployees' }
      },
      {
        path: 'exitclearance',
        component: NewExitclearanceComponent,
        data: { title: 'exitclearance' }
      },
      {
        path: 'approveexitclearance',
        component: ApproveExitClearanceComponent,
        data: { title: 'approveexitclearance' }
      },
      {
        path: 'authorizeclearance',
        component: AuthorizeExitClearanceComponent,
        data: { title: 'authorizeclearance' }
      },
      {
        path: 'exitclearanceforms',
        component: ExitClearanceFormsComponent,
        data: { title: 'exitclearanceforms' }
      },
      {
        path: 'exitclearanceUserManagement',
        component: ExitEmployeeUserMgtComponent,
        data: { title: 'exitclearanceUserManagement' }
      },
      {
        path: 'exitclearancereport',
        component: ExitClearanceReportComponent,
        data: { title: 'exitclearancereport' }
      },
      {
        path: 'createadhocrequest',
        component: NewAdhocComponent,
        data: { title: 'createadhocrequest' }
      },
      {
        path: 'approveadhocrequests',
        component: ViewApproveadhocComponent,
        data: { title: 'approveadhocrequests' }
      },
      {
        path: 'adhocrequests',
        component: ViewAdhocComponent,
        data: { title: 'adhocrequests' }
      },
      {
        path: 'createjobrotationrequest',
        component: NewJobRotationComponent,
        data: { title: 'createjobrotationrequest' }
      },
      {
        path: 'viewjobrotations',
        component: ViewJobRotationsComponent,
        data: { title: 'viewjobrotations' }
      },
      {
        path: 'approvejobrotation',
        component: ApproveJobRotationComponent,
        data: { title: 'approvejobrotation' }
      },
      {
        path: 'adhocrequestreport',
        component: AdhocRequestReportsComponent,
        data: { title: 'adhocrequestreport' }
      },
    ]
  },
  { path: 'signin', component: SigninComponent },
  { path: 'passwordreset', component: FirstLogonComponent, canActivate:[AuthenticationGuard] },
 { path: 'approve', component: ApproveComponent, canLoad:[AuthenticationGuard]  },
 { path: 'approvemovement', component: ApprovemvtComponent, canLoad:[AuthenticationGuard]  },
 { path: 'approvemp', component: ApprovemanpComponent, canLoad:[AuthenticationGuard]  },
 { path: 'confirmtool', component: ConfirmtoolsComponent, canLoad:[AuthenticationGuard]  },
 
 {
  path: 'employeeauthorizeclearance',
  component: ConfirmClearanceComponent,
  canLoad:[AuthenticationGuard] 
},
 {
  path: 'employeeonboarding',
  component: DocumentationNewHireComponent,
  // canLoad:[AuthenticationGuard] 
},
 
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
